<template>
  <OmtLayoutContainer>
    <OmtRow mb="8px">
      <OmtTypography as="h1-regular"><b>Envio das imagens</b> (opcional)</OmtTypography>
    </OmtRow>
    <OmtRow mb="24px">
      <OmtTypography as="h3-bold">Adicione imagens que ajudem na análise da sua solicitação:</OmtTypography>
    </OmtRow>

    <OmtRow>
      <ImageUploader :length="limitFiles" :initialValue="pictures"
@change="onImageUploaderChange" />
    </OmtRow>

    <OmtRow :desktopStart="1" :desktopEnd="6"
:gridRowStart="['initial', '2']">
      <CBox>
        <CFlex mb="8px">
          <OmtIcons name="check" size="lg" mr="16px" color="var(--colors-light-support-success)" />
          <OmtTypography as="p1"><b>Arquivos suportados:</b> .jpg, .png, .heic e .pdf. com até 25mb.</OmtTypography>
        </CFlex>
        <CFlex mb="8px">
          <OmtIcons name="check" size="lg" mr="16px" color="var(--colors-light-support-success)" />
          <OmtTypography as="p1">Envie apenas <b>um documento por foto</b>.</OmtTypography>
        </CFlex>
        <CFlex mb="8px">
          <OmtIcons name="check" size="lg" mr="16px" color="var(--colors-light-support-success)" />
          <OmtTypography as="p1">Certifique-se de que todas as informações das imagens estão legíveis.</OmtTypography>
        </CFlex>
      </CBox>
    </OmtRow>

    <OmtRow mt="48px" justifyContent="center">
      <OmtButton :w="['100%', '308px !important']" @click="send">Enviar</OmtButton>
    </OmtRow>

    <SentRequestModal
      :isOpen="modalSuccess"
      :isOuvidoria="false"
      flowType="healthPrograms"
      :daysAnalizy="daysAnalizy"
      :protocol="protocolo"
      @close="closeModal"
      @save="concluirAvaliacao"
    />
  </OmtLayoutContainer>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import ImageUploader from "@/components/Molecules/ImageUploader";
import SentRequestModal from "@/components/Organisms/Requests/SentRequestModal.vue";

export default {
  name: "UploadFileRequest",
  components: { ImageUploader, SentRequestModal },
  data() {
    return {
      pictures: [],
      daysAnalizy: 0,
      modalSuccess: false,
      protocolo: "",
      sending: false,
      detail: {}
    };
  },
  computed: {
    ...mapState("saude", ["vinculo"]),
    ...mapState("programasSaude", ["newSolicitation"]),
    ...mapState("request", ["limitFiles"]),
    baseData() {
      return this.detail || {};
    },
    hasPendency() {
      const p = this.baseData.Pendencia || this.baseData.Pendencias;
      if (!p) return false;

      if (this.baseData.Pendencia) {
        const pend = this.baseData.Pendencia;
        return (Array.isArray(pend.Motivos) && pend.Motivos.length > 0) || !!pend.Observacao;
      }

      if (Array.isArray(this.baseData.Pendencias)) {
        return this.baseData.Pendencias.length > 0;
      }

      return false;
    }
  },
  methods: {
    ...mapMutations("sac", ["SET_SUCCESS_REQUEST"]), // flag lida pelo list.vue
    onImageUploaderChange(pictures) {
      this.pictures = Array.isArray(pictures) ? pictures.filter(p => p && (p.file || p.source)) : [];
    },
    closeModal() {
      this.modalSuccess = false;
    },

    _filesFromPictures() {
      if (!Array.isArray(this.pictures)) return [];
      return this.pictures.map(p => p.file || p).filter(f => f instanceof File);
    },

    _buildPayloadData() {
      return {
        Tipo: this.newSolicitation?.tipoSolicitacao ?? 0,
        Beneficiario: this.newSolicitation?.beneficiario || "",
        Observacao: (this.newSolicitation?.observacao || "").slice(0, 2000),
        Autenticacao: Number(this.newSolicitation?.autenticacao ?? 0),
        Vinculo: this.vinculo ?? null
      };
    },

    async send() {
      if (this.sending) return;
      this.sending = true;

      try {
        this.$root.$emit("show-loading");

        const arquivos = this._filesFromPictures();

        const payloadData = this._buildPayloadData();

        const respCriacao = await this.$store.dispatch("programasSaude/criarNovaSolicitacao", {
          pictures: this.pictures,
          data: payloadData
        });

        this.protocolo =
          respCriacao?.protocoloANS ??
          respCriacao?.Data?.ProtocoloANS ??
          this.$store.getters["programasSaude/protocoloAtual"] ??
          "";

        if (this.hasPendency) {
          const arquivosPendency = arquivos.slice(0, 20);
          await this.$store.dispatch("programasSaude/enviarRetornoPendencia", {
            protocolo: this.protocolo,
            observacao: this.newSolicitation?.observacao || "",
            arquivos: arquivosPendency
          });
        }

        this.modalSuccess = true;

        this.$toast({
          description: "Solicitação registrada com sucesso.",
          status: "success",
          duration: 5000,
          position: "top"
        });
      } catch (err) {
        console.error(err);
        this.$toast({
          description: "Erro ao registrar avaliação.",
          status: "error",
          duration: 5000,
          position: "top"
        });
      } finally {
        this.$root.$emit("hide-loading");
        this.sending = false;
      }
    },

    async concluirAvaliacao({ rating }) {
      try {
        this.$root.$emit("show-loading");

        await this.$store.dispatch("programasSaude/avaliacao", {
          protocolo: this.protocolo,
          Nota: Number(rating)
        });

        this.$toast({
          description: "Avaliação enviada com sucesso.",
          status: "success",
          duration: 5000,
          position: "top"
        });

        await this.$store.dispatch("programasSaude/fetchProtocolos", { force: true });

        this.SET_SUCCESS_REQUEST(true);

        await this.$router.push({ path: "/programas-saude", query: { refresh: Date.now() } });
      } catch (err) {
        console.error(err);
        this.$toast({
          description: "Erro ao enviar solicitação.",
          status: "error",
          duration: 5000,
          position: "top"
        });
      } finally {
        this.$root.$emit("hide-loading");
      }
    }
  }
};
</script>
